/**
 * RENDERIZA CALENDÀRIO
 */
function calendarRender($params) {
    var calendarRender = $("#calendarRender");
    $.ajax({
        url: url("/calendar/render"),
        data: $params,
        type: "POST",
        beforeSend: () => {
            calendarLoader();
        },
        success: (result) => {
            calendarLoaderClose();
            setTimeout(() => {
                calendarRender.html(result).fadeIn(300);
            }, 500);
        }
    });
}

/**
 * AÇÃO AO CLICAR EM UM DIA
 */
$("body").on("click", ".js_btnDayCalendar", function(e) {
    e.preventDefault();
    var data = $(this).data();

    $.ajax({
        url: url(data.link),
        data: data,
        type: "POST",
        dataType: "JSON",
        beforeSend: () => {
            calendarLoader();
        },
        success: (response) => {

            if (response.message) {
                calendarLoaderClose();

                //sweth alert
                if (response.dashboard) {
                    Swal.fire({
                        title: "Ops!",
                        text: response.message,
                        icon: "error"
                    });
                    return;
                }
                //magnific popup
                var modal_size = "sm"
                var modal = "#modal_" + modal_size;
                $(".modal_title_" + modal_size).html("");
                $(".modal_content_" + modal_size).html(response.message);
                openModal(modal);
                return;
            }

            if (response.redirect) {
                setTimeout(() => {
                    location.href = response.redirect;
                }, 1000);
            }

            if (response.associateSchedule) {
                setTimeout(() => {
                    Swal.fire({
                        title: "Agendado!",
                        icon: "success",
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    //atualiza modal e table
                    $.post(url(CONF_URL_ADMIN + "/associado/agendamento/modalview"), {id:response.associateSchedule}, function (view) {
                        $("#modal .modal-body").html(view);
                        table.ajax.reload();
                        $("#modal2").modal("hide");
                    });
                }, 1000);
            }
        }
    });
});

/**
 * LOADER
 */
function calendarLoader() {
    $('.calendar-wrap').append(loaderCalContent).fadeIn(500);
};

function calendarLoaderClose() {
    setTimeout(() => {
        $(".calendar-loader").fadeOut(100);
    }, 1000);
}

var loaderCalContent =
    '<div class="calendar-loader">'
        +'<div class="calendar-loader__wrap d-table text-center">'
            +'<div class="sk-three-bounce d-table-cell align-middle">'
                + '<div class="sk-child sk-bounce1 sk-color-app"></div>'
                + '<div class="sk-child sk-bounce2 sk-color-app"></div>'
                + '<div class="sk-child sk-bounce3 sk-color-app"></div>'
            + '</div>';
        + '</div>';
    + '</div>';




